<div class="w-full bg-white h-[600px]">
  <nz-layout class="h-full">
    <nz-sider class="bg-white" nzWidth="220px">
      <div class="h-full flex flex-col justify-between">
        <ul nz-menu nzMode="vertical" class="h-full">
          <li nz-menu-item nzSelected class="rounded-lg mr-16" (click)="showItem(0)">
            <div class="flex items-center gap-8">
              <twaice-fe-svg-icon name="user" source="tabler" size="16px" />
              Account Information
            </div>
          </li>
          <li nz-menu-item *ngIf="!isSSOUser" class="rounded-lg mr-16" (click)="showItem(1)">
            <div class="flex items-center gap-8">
              <twaice-fe-svg-icon name="key" source="tabler" size="16px" />
              Change Password
            </div>
          </li>
          <li nz-menu-item class="rounded-lg mr-16" (click)="showItem(2)">
            <div class="flex items-center gap-8">
              <twaice-fe-svg-icon name="world" source="tabler" size="16px" />
              Date & time
            </div>
          </li>
          <li nz-menu-item *ngIf="authService.isInternalUser() | async" class="rounded-lg mr-16" (click)="showItem(3)">
            <div class="flex items-center gap-8">
              <twaice-fe-svg-icon name="layout-dashboard" source="tabler" size="16px" />
              Internal UI Config
            </div>
          </li>
        </ul>
        <p *ngIf="authService.isInternalUser() | async" class="font-thin mb-0 text-tertiary-text text-xs">{{ release }}</p>
      </div>
    </nz-sider>
    <nz-content class="bg-white overflow-y-auto">
      <div class="w-full h-full p-8 pl-16">
        @switch (activeItem) {
          @case (0) {
            <twaice-fe-account-overview />
          }
          @case (1) {
            <twaice-fe-password-change />
          }
          @case (2) {
            <twaice-fe-timezone />
          }
          @case (3) {
            <twaice-fe-internal-ui-config />
          }
        }
      </div>
    </nz-content>
  </nz-layout>
</div>
